import * as React from "react";

interface SwitchProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  // P1-B (2026-09-08): plan-locked module toggles need a disabled state.
  disabled?: boolean;
}

export function Switch({ checked = false, onCheckedChange, className, disabled = false }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => { if (!disabled) onCheckedChange?.(!checked); }}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: '52px',
        height: '28px',
        borderRadius: '9999px',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        padding: '2px',
        backgroundColor: checked ? '#36CCD8' : '#6B7280',
        transition: 'background-color 200ms ease-in-out',
      }}
      className={className}
    >
      <span
        style={{
          display: 'block',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          transform: checked ? 'translateX(24px)' : 'translateX(0)',
          transition: 'transform 200ms ease-in-out',
        }}
      />
    </button>
  );
}
